import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { loadScript } from './scripts';
import { LocalizationService } from '../localization/localization.service';
import { Locales } from '../localization/locales';

@Injectable()
export class RecaptchaService {
  private loadedSubject;

  constructor(
    private localizationService: LocalizationService,
  ) {
  }

  load() {
    if (!this.loadedSubject) {
      this.loadedSubject = new ReplaySubject<boolean>(1);
      (window as any).recaptchaLoaded = () => {
        this.loadedSubject.next(true);
      };
      const lang = this.localizationService.getLocale() === Locales.en ? 'en' : 'ru';
      loadScript(`https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit&hl=${lang}`);
    }

    return this.loadedSubject;
  }
}
